import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { loginBytoken, logout, selectUser } from '../../domain/userSlice';
import { ACCESS_TOKEN } from '../../../app/api-client/constants';

const withAuthentication = Component => (props) => {

  const dispatch = useDispatch();

  const user = useSelector(selectUser);
  const token = localStorage.getItem(ACCESS_TOKEN);

  useEffect(() => {
    const setDispatch = async () => {
      if (!token) {
        await dispatch(logout());
        return;
      }

      if (!user) {
        await dispatch(loginBytoken())
      }
    }
    setDispatch();
  }, [dispatch, token, user]);
  return <Component {...props} />;

};

export default withAuthentication;